// cluster/components/form/TariffForm.tsx
import React from 'react'
import { Input } from '../../../../../common/components/input/Input'
import { useTariffForm } from './useTariffForm'
import classes from './TariffForm.module.sass'
import { TariffRule } from '../../../../../common/types/interfaces'
import DateFilter from '../../../../../common/components/listControl/dateFilter/DateFilter'
import { Toggle } from '../../../../../common/components/newToggle/Toggle'
import { Button } from '../../../../../common/components/button/Button'

type Props = {
  tariff: TariffRule | undefined
  setTariff: (data: TariffRule) => void
}

export const TariffForm = ({ tariff, setTariff }: Props) => {
  const {
    inputHandler,
    toggleAction,
    getValidationResult,
    setDirty,
    handleDateChange,
    setDurationPreset,
  } = useTariffForm({ tariff, setTariff })

  return (
    <div className={classes.container}>
      <div className={classes.groupFormContainer}>
        <Input
          label={'Название тарифа'}
          type={'text'}
          fieldName={'name'}
          value={tariff?.name || ''}
          placeHolder={'Название тарифа'}
          onChangeHandler={inputHandler}
          itemValidationResult={getValidationResult('name')}
          onBlur={setDirty}
        />

        <Input
          label={'Базовая цена (руб)'}
          type={'numberText'}
          fieldName={'basePrice'}
          value={tariff?.basePrice || ''}
          placeHolder={'Базовая цена (руб)'}
          onChangeHandler={inputHandler}
          itemValidationResult={getValidationResult('basePrice')}
          onBlur={setDirty}
        />

        <Input
          label={'Спец. цена (руб, опционально)'}
          type={'numberText'}
          fieldName={'specialPrice'}
          value={tariff?.specialPrice || ''}
          placeHolder={'Спец. цена (руб, опционально)'}
          onChangeHandler={inputHandler}
          itemValidationResult={getValidationResult('specialPrice')}
          onBlur={setDirty}
        />

        <div className={classes.toggleContainer}>
          <Toggle
            onChange={() => toggleAction('isPaid')}
            checked={tariff?.isPaid || false}
          />
          <div>Платное обслуживание</div>
        </div>

        <div className={classes.toggleContainer}>
          <Toggle
            onChange={() => toggleAction('allowDiscounts')}
            checked={tariff?.allowDiscounts || false}
          />
          <div>Разрешить скидки за длительность</div>
        </div>

        <div className={classes.toggleContainer}>
          <Toggle
            onChange={() => toggleAction('datesImportant')}
            checked={tariff?.datesImportant || false}
          />
          <div>Указать срок действия</div>
        </div>

        {tariff?.datesImportant && (
          <>
            <div className={classes.presetButtons}>
              {[1, 3, 6, 12, 18].map((months) => (
                <Button
                  key={months}
                  small
                  text={`${months} мес`}
                  onClick={() => setDurationPreset(months)}
                />
              ))}
            </div>
            <div className={classes.row}>
              <DateFilter
                range={{
                  from: tariff?.validFrom ? new Date(tariff.validFrom as string) : new Date(),
                  to: tariff?.validTo ? new Date(tariff.validTo as string) : new Date(),
                }}
                onChange={(value, isFrom) => handleDateChange(value, isFrom || false)}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}